import React, { useCallback } from 'react';
import { DawidButtonsBar } from '../buttons_bar.jsx';
import {
    useUiStore,
    useSessionStore,
    useSyncBridge,
    useFlowStoreInstance,
    useSessionStoreInstance,
} from '../../store/react';
import { exportStateBlob, parseImportedBlob } from '../../session/localPersistence';

export default function ButtonsBarWrapper() {
    const bridge = useSyncBridge();
    const connected = useSessionStore((s) => s.connected);
    const sessionCreated = useSessionStore((s) => s.sessionCreated);
    const mode = useSessionStore((s) => s.mode);
    const expiration = useSessionStore((s) => s.expiration);
    const sessionIdPublic = useSessionStore((s) => s.sessionIdPublic);
    const sessionIdPrivate = useSessionStore((s) => s.sessionIdPrivate);
    const emailAddress = useUiStore((s) => s.emailAddress);
    const setEmailAddress = useUiStore((s) => s.setEmailAddress);
    const flowStore = useFlowStoreInstance();
    const sessionStore = useSessionStoreInstance();

    const createSession = useCallback(() => bridge && bridge.createSession(), [bridge]);
    const joinSession = useCallback(
        (e) => bridge && bridge.joinSession({
            sessionIdPublic: e.sessionIdPublic,
            sessionIdPrivate: e.sessionIdPrivate,
        }),
        [bridge],
    );
    const deleteSession = useCallback(() => bridge && bridge.deleteSession(), [bridge]);
    const exportState = useCallback(() => {
        const sess = sessionStore.getState();
        return exportStateBlob({
            sessionIdPublic: sess.sessionIdPublic,
            sessionIdPrivate: sess.sessionIdPrivate,
            topicsSuffix: sess.topicsSuffix,
            expiration: sess.expiration,
            snapshot: flowStore.getState(),
        });
    }, [flowStore, sessionStore]);
    const importState = useCallback((raw) => {
        const parsed = parseImportedBlob(raw);
        if (!parsed) return;
        if (parsed.state) flowStore.getState().restoreSnapshot(parsed.state);
        if (parsed.sessionIdPublic) {
            sessionStore.getState().sessionJoined({
                session_id_public: parsed.sessionIdPublic,
                session_id_private: parsed.sessionIdPrivate,
                topics_suffix: parsed.topicsSuffix,
                expiration: parsed.expiration,
            });
        }
    }, [flowStore, sessionStore]);

    return (
        <DawidButtonsBar
            clientConnected={connected}
            sessionCreated={sessionCreated}
            mode={mode}
            expiration={expiration}
            sessionIdPublic={sessionIdPublic}
            sessionIdPrivate={sessionIdPrivate}
            emailAddress={emailAddress}
            submitEmail={setEmailAddress}
            createSession={createSession}
            joinSession={joinSession}
            deleteSession={deleteSession}
            exportState={exportState}
            importState={importState}
        />
    );
}
